import { CloseSharp } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useContext } from "react";
import { AppContext } from "../context/app.context";
import { CurrentCar } from "../reducers/config";
import { useDispatch } from "react-redux";

const DeleteCart = ({ openDelete, setOpenDelete, selectedCar }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { fetchCartList, setCarValue } = useContext(AppContext);

  //Functions
  function handleClose() {
    setOpenDelete(false);
  }

  //APIs
  const deleteCart = async () => {
    try {
      const response = await global.$axios.get(
        `cart/clear/${global.$userData.id}`
      );
      if (response.data.status === "success") {
        handleClose();

        // localStorage.setItem("CurrentCar", JSON.stringify(selectedCar));
        dispatch(CurrentCar(selectedCar));

        setCarValue(selectedCar);
        await fetchCartList();
      } else {
        console.log("Delete Cart Issue", response.data);
      }
    } catch (error) {
      console.log("Delete Cart Issue", error);
    }
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      open={openDelete}
      fullWidth={true}
      maxWidth={"sm"}
      aria-labelledby="draggable-dialog-title"
      onClose={handleClose}
    >
      <Grid sx={{ py: 2, px: 3 }}>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle>
            <Typography sx={{ p: 0, color: "#071CB7", fontWeight: 600 }}>
              Delete Cart
            </Typography>
          </DialogTitle>
          <IconButton sx={{ p: 0 }} onClick={handleClose}>
            <CloseSharp sx={{ color: "red" }} />
          </IconButton>
        </Grid>

        <DialogContent sx={{ px: { sm: 5, xs: 0 } }}>
          <Grid>
            <Typography sx={{ textAlign: "center" }}>
              You have items in your cart. Would you like to clear your cart and
              change the vehicle
            </Typography>
            <Grid
              sx={{
                justifyContent: "space-around",
                alignItems: "center",
                mt: 5,
              }}
              container
            >
              <Button
                onClick={handleClose}
                sx={{
                  textTransform: "capitalize",
                  background: "#CCD0FF",
                  color: "#000",
                  width: "20%",
                }}
                variant="contained"
                size="small"
              >
                No
              </Button>
              <Button
                onClick={deleteCart}
                sx={{
                  textTransform: "capitalize",
                  background: "#071CB7",
                  width: "20%",
                }}
                variant="contained"
                size="small"
              >
                Clear Cart
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Grid>
    </Dialog>
  );
};

export default DeleteCart;
